import axios from "axios";
export const GET_TIPOS_CLAUSULAS_CERTIFICADO =
  "GET_TIPOS_CLAUSULAS_CERTIFICADO";
export const GET_NOMINAS_ACTIVAS = "GET_NOMINAS_ACTIVAS";
export const DOWNLOAD_CERTIFICADO_COBERTURA = "DOWNLOAD_CERTIFICADO_COBERTURA";
export const ENVIAR_CERTIFICADO_COBERTURA = "ENVIAR_CERTIFICADO_COBERTURA";
export const VALIDAR_IMPORTACION_NOMINAS = "VALIDAR_IMPORTACION_NOMINAS";
export const SAVE_DATOS_VIAJE_EXTERIOR = "SAVE_DATOS_VIAJE_EXTERIOR";
export const CLEAR_CERTIFICADO_COBERTURA = "CLEAR_CERTIFICADO_COBERTURA";
export const SAVE_SELECCION_DE_NOMINAS = "SAVE_SELECCION_DE_NOMINAS";
export const getTiposClausulasCertificado = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_CLAUSULAS_CERTIFICADO,
    payload: axios
      .get("certificadoCobertura/tiposClausulaCertificado")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getNominasActivas = () => (dispatch) => {
  return dispatch({
    type: GET_NOMINAS_ACTIVAS,
    payload: axios
      .get("nomina/activas")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const downloadCertificadoCobertura = (body) => (dispatch) => {
  return dispatch({
    type: DOWNLOAD_CERTIFICADO_COBERTURA,
    payload: axios
      .post("certificadoCobertura/descargar", body, {
        responseType: "blob",
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const enviarCertificadoCobertura = (body) => (dispatch) => {
  return dispatch({
    type: ENVIAR_CERTIFICADO_COBERTURA,
    payload: axios
      .post("certificadoCobertura/enviarMail", body)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const validarImportacionNominas = (body) => (dispatch) => {
  return dispatch({
    type: VALIDAR_IMPORTACION_NOMINAS,
    payload: axios
      .post("certificadoCobertura/validarImportacionNominas", body)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const saveDatosDelViajeExterior = (values) => (dispatch) => {
  return dispatch({
    type: SAVE_DATOS_VIAJE_EXTERIOR,
    payload: values,
  });
};

export const saveSeleccionDeNominas = (values) => (dispatch) => {
  return dispatch({
    type: SAVE_SELECCION_DE_NOMINAS,
    payload: values,
  });
};

export const clearCertificadoDeCobertura = (values) => (dispatch) => {
  return dispatch({
    type: CLEAR_CERTIFICADO_COBERTURA,
  });
};
